<!-- part3学习策略分析 -->
<!-- 认知，情感，行为倾向，学习动力... 等 -->
<template>
	<div class="part3_1_main_box">
		<P class="main_title"><span class="block"></span>{{title}}<span :class="['name', 'name'+type]">{{name}}</span></P>
		<!-- <div class="main_norm_box">
			<div class="norm_box">
				<div :class="['norm_block' , 'norm_block_'+item]" v-for="item in 5">
					<div :class="['grade', 'grade_' + item]" v-if="item == getGrade(normObj.score)">
					</div>
				</div>
				<div class="norm_bg">
					<div class="bg" v-for="item in 5" v-if="item > getGrade(normObj.score)"></div>
				</div>
			</div>
		</div> -->
		<div class="main_norm_box">
			<div class="rule_box rule_box_part2">
				<img src="~@/assets/report_imgs/norm_rule5.png" alt="">
			</div>
			<div class="norm_box">
				<div class="norm_block norm_block_part2" :style="{left: normObj.lnorm/5*670 + 'px', width: (normObj.rnorm-normObj.lnorm)/5*670 + 'px' }" :title="normObj.lnorm + '~' +normObj.rnorm"></div>
				<div :class="['norm_score','part3_score_'+type]" :style="{left: normObj.score/5*670-30 + 'px'}">{{normObj.score | toFixed(2)}}</div>
			</div>
		</div>
<!-- 		<p class="gradeName">你在{{name}}水平为<span :class="'score'+type">{{getGradeName(normObj.score)}}</span>。</p> -->
		<p class="main_detail">你在{{normObj.name}}的水平值为<span :class="'c_score_tyep' + type">{{normObj.score | toFixed(2)}}</span>，水平为
			<span :class="'c_score_tyep' + type" v-if="normObj.score <= 1">低</span>
			<span :class="'c_score_tyep' + type" v-else-if="normObj.score <= 2">较低</span>
			<span :class="'c_score_tyep' + type" v-else-if="normObj.score <= 3">中等</span>
			<span :class="'c_score_tyep' + type" v-else-if="normObj.score <= 4">较高</span>
			<span :class="'c_score_tyep' + type" v-else-if="normObj.score <= 5">高</span>，你超过了<span :class="'c_score_tyep' + type">{{normObj.percent*100 | toFixed(2)}}%</span>的同龄人。
		</p>
		<p class="main_remark"><span class="remark">备注</span>本测评水平值范围0~5，{{normObj.name}}平均水平值为<span class="c_orange">{{normObj.lnorm}}~{{normObj.rnorm}}</span>。</p>
		<P class="main_directions">{{comment.comment}}</P>
	</div>
</template>
<script>
export default {
	name: 'page_part3_main',
	components: {  },
    props: {
    	normObj: {
	      type: Object//norm数组的其中一项
	      // required: true
	    },
	    comment: {
	   		type: Object//comment的类型解读
	      	// required: true
	    },
	    title: {
	    	type: String
	    },
	   	name: {
	    	type: String
	    },
	   	type: {
	    	type: String
	    }
    },
    data() {
        return {
        }
    },
    watch: {
    },
    created() {	
    },
    mounted() {
    },
    methods: {
    	getGrade(value) {
    		if(value <= 1) {
                return 1;
            }else if(value <= 2) {
                return 2;
            }else if(value <= 3) {
                return 3;
            }else if(value <= 4) {
                return 4;
            }else {
                return 5;
            }
    	},
    	getGradeName(value) {
            if(value <= 1) {
                return '低';
            }else if(value <= 2) {
                return '较低';
            }else if(value <= 3) {
                return '中等';
            }else if(value <= 4) {
                return '较高';
            }else {
                return '高';
            }
    	}

    }
}
</script>
<style type="text/css" lang='less' scoped>
	@import './report.less';
	.part3_1_main_box {
		margin-bottom: 60px;
		.part3_score_1 {
			background: url(~@/assets/report_imgs/icon_part3type1.png) no-repeat center center;
		}
		.part3_score_2 {
			background: url(~@/assets/report_imgs/icon_part3type2.png) no-repeat center center;
		}
		.part3_score_3 {
			background: url(~@/assets/report_imgs/icon_part3type3.png) no-repeat center center;
		}
		.c_score_tyep1 {
			color: #ff9f7b;
		}
		.c_score_tyep2 {
			color: #e77178;
		}
		.c_score_tyep3 {
			color: #41cbaa;
		}
		.main_title {
			display: flex;
			align-items: center;
			color: #333;
			font-size: 16px;
			font-weight: bold;
			// margin-bottom: 25px;
			.block {
				width: 10px;
				height: 10px;
				margin-right: 5px;
				border-radius: 2px;
				background-color: #333;
			}
			.name1 {
				color: #ff9f7b;
			}
			.name2 {
				color: #E8777E;
			}
			.name3 {
				color: #19ADA7;
			}
		}
		.gradeName {
			margin-bottom: 35px;
			font-size: 14px;
			span {
				font-size: 16px;
				font-weight: bold;
			}
			.score1 {
				color: #FF9F7B;
			}
			.score2 {
				color: #FA8AA5;
			}
			.score3 {
				color: #46CCAC;
			}
		}
		.main_directions {
			padding: 25px;
			font-size: 14px;
			color: #8A8A8A;
			line-height: 28px; 
			background-color: #F7F7F7;
			border-radius: 5px;
		}
		// .main_norm_box {
		// 	padding: 80px 0 40px 0;
		// 	.norm_box {
		// 		width: 712px;
		// 		height: 23px;
		// 		background-image: -webkit-linear-gradient(left, #fdab74, #fe8e84);
		// 		background-image: -o-linear-gradient(left, #fdab74, #fe8e84);
		// 		background-image: linear-gradient(to right, #fdab74, #fe8e84);
		// 		display: flex;
		// 		position: relative;
		// 		.grade_1 {
		// 			background-image: url(~@/assets/report_imgs/icon_feichangcha.png);
		// 		}
		// 		.grade_2 {
		// 			background-image: url(~@/assets/report_imgs/icon_jiaocha.png);
		// 		}
		// 		.grade_3 {
		// 			background-image: url(~@/assets/report_imgs/icon_yiban.png);
		// 		}
		// 		.grade_4 {
		// 			background-image: url(~@/assets/report_imgs/icon_jiaohao.png);
		// 		}
		// 		.grade_5 {
		// 			background-image: url(~@/assets/report_imgs/icon_feichanghao.png);
		// 		}
		// 		.f_border {
		// 			width: 0;
		// 		}
		// 		.norm_block {
		// 			// box-sizing: border-box;
		// 			height: 23px;
		// 			position: relative;
		// 			width: 20%;
		// 			border-right: 2px solid #fff; 
		// 			.grade {
		// 				position: absolute;
		// 				top: -79px;
		// 				width: 45px;
		// 				height: 77px;
		// 				left: 50%;
		// 				margin-left: -22px;
		// 			}
		// 		}
		// 		.norm_bg {
		// 			width: 712px;
		// 			height: 23px;
		// 			position: absolute;
		// 			left: 0;
		// 			top: 0;
		// 			display: flex;
		// 			justify-content: flex-end;
		// 			.bg {
		// 				width: 20%;
		// 				box-sizing: border-box;
		// 				border-right: 2px solid #fff; 
		// 				background-color: #DADEE2;
		// 				&:last-child {
		// 					border: none;
		// 				}
		// 			}
		// 		}
		// 	}
		// 	.norm_block_5 {
		// 		border-right: none;
		// 	}
		// }
	}
</style>
